import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const LocationInfo = ({ asset }) => {
  const [departmentId, setDepartmentId] = useState("");
  const [associateId, setAssociateId] = useState("");
  const [locationId, setLocationId] = useState("");
  const [statusId, setStatusId] = useState("");

  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [locations, setLocations] = useState([]);
  const [statuses, setStatuses] = useState([]);

  // --------------------------------------------------------
  // INITIAL LOAD FROM API
  // --------------------------------------------------------
  useEffect(() => {
    if (asset) {
      setDepartmentId(asset.department_id ?? "");
      setAssociateId(asset.associate_id ?? "");  // FIXED
      setLocationId(asset.location_id ?? "");
      setStatusId(asset.status_id ?? "");

      setDepartments(asset.all_departments || []);
      setEmployees(asset.employee_list || []);      // initial employees
      setLocations(asset.location_list || []);
      setStatuses(asset.assets_status || []);
    }
  }, [asset]);

  // --------------------------------------------------------
  // LOAD EMPLOYEES BASED ON SELECTED DEPARTMENT
  // --------------------------------------------------------
  const loadEmployees = async (dept_id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/department/${dept_id}/employees`);
      setEmployees(res.data);
    } catch (err) {
      console.error("Employee load error:", err);
      toast.error("Failed to load employees!", { position: "bottom-right" });
    }
  };

  const handleDepartmentChange = async (selected) => {
    setDepartmentId(selected.department_id);
    setAssociateId(""); // reset selection
    await loadEmployees(selected.department_id);
  };

  // --------------------------------------------------------
  // SAVE LOCATION INFO
  // --------------------------------------------------------
const handleSave = async (e) => {
  e.preventDefault();

  const token = localStorage.getItem("authToken"); // ✅ FIXED

  const selectedEmp = employees.find((e) => e.user_id == associateId);

  const payload = {
    asset_id: asset.assets_id,
    department_id: departmentId,
    associate_id: associateId,
    location_id: locationId,
    status_id: statusId,

    old_status: asset.status_name,
    old_deptName: asset.department_name,
    old_empName: asset.emp_name,
    old_location: asset.location_name,

    new_status:
      statuses.find((s) => s.status_id == statusId)?.status_name || "",
    new_deptName:
      departments.find((d) => d.department_id == departmentId)
        ?.department_name || "",
    new_empName: selectedEmp
      ? `${selectedEmp.first_name} ${selectedEmp.last_name} (${selectedEmp.employee_id})`
      : "",
    new_location:
      locations.find((l) => l.loc_id == locationId)?.place_name || "",
  };

  try {
    await axios.post(
      `${API_BASE_URL}/asset/location-info`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    toast.success("Location information updated!", {
      position: "bottom-right",
    });
  } catch (err) {
    console.error("Update failed:", err);
    toast.error("Update failed!", { position: "bottom-right" });
  }
};


  return (
    <div className="card p-3">
      <h5 className="mb-3">Location Information</h5>

      <form onSubmit={handleSave}>
        <div className="row">

          {/* Department */}
          <div className="col-md-4 mb-3">
            <label>Department</label>
            <Select
              value={
                departments.find((d) => d.department_id == departmentId) || null
              }
              onChange={handleDepartmentChange}
              options={departments}
              getOptionLabel={(d) => d.department_name}
              getOptionValue={(d) => d.department_id}
              placeholder="Select Department"
              isSearchable
            />
          </div>

          {/* Employee */}
          <div className="col-md-4 mb-3">
            <label>Associate To</label>
            <Select
              value={employees.find((emp) => emp.user_id == associateId) || null}
              onChange={(selected) => setAssociateId(selected.user_id)}
              options={employees}
              getOptionLabel={(emp) =>
                `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
              }
              getOptionValue={(emp) => emp.user_id}
              placeholder="Select Employee"
              isSearchable
            />
          </div>

          {/* Location */}
          <div className="col-md-4 mb-3">
            <label>Location</label>
            <Select
              value={locations.find((loc) => loc.loc_id == locationId) || null}
              onChange={(selected) => setLocationId(selected.loc_id)}
              options={locations}
              getOptionLabel={(loc) =>
                `${loc.block_name} / ${loc.floor_name} / ${loc.place_name}`
              }
              getOptionValue={(loc) => loc.loc_id}
              placeholder="Select Location"
              isSearchable
            />
          </div>

        </div>

        <div className="row">
          {/* Status */}
          <div className="col-md-4 mb-3">
            <label>Status</label>
            <Select
              value={statuses.find((s) => s.status_id == statusId) || null}
              onChange={(selected) => setStatusId(selected.status_id)}
              options={statuses}
              getOptionLabel={(s) => s.status_name}
              getOptionValue={(s) => s.status_id}
              placeholder="Select Status"
              isSearchable
            />
          </div>
        </div>

        <button className="btn btn-primary btn-sm mt-2" type="submit">
          Save
        </button>
      </form>
    </div>
  );
};

export default LocationInfo;
